import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import { t } from '../../i18n';

export class IncidentNotificationProcedure extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'incidentNotification'}
            title={ t('support.procedure.P18.title') }
            exportTitle={ t('support.procedure.P18.exportTitle') }
            exportFileName={'incidentNotification.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (IncidentNotificationProcedure);
